import { SYSTEM_CONTEXT_IDS } from 'modules/niche/common/niche.consts'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const TOTAL_CONTEXT_TO_BRAND_TYPE: Record<string, 'owned' | 'earned' | 'paid'> = {
  [SYSTEM_CONTEXT_IDS.launches]: 'owned',
  [SYSTEM_CONTEXT_IDS.promotionsDiscounts]: 'owned',
  [SYSTEM_CONTEXT_IDS.trendingProducts]: 'earned',
  [SYSTEM_CONTEXT_IDS.painPoints]: 'earned',
  [SYSTEM_CONTEXT_IDS.paidPartnership]: 'paid',
  [SYSTEM_CONTEXT_IDS.sponsoredEvents]: 'paid',
}

export const GET_BRAND_TERRITORIES_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-territory-resolver/index.ts',
  name: 'Get Brand Territories',
  message: 'Failed to fetch brand territories for niche context resolution',
}
